const pkg = require('../../package.json')

module.exports = {
  footerText: `Version ${pkg.version}`
}
